// extracted by mini-css-extract-plugin
export const modal = "modal-module--modal--3TOOS";
export const wrapper = "modal-module--wrapper--17aH0";
export const back = "modal-module--back--tPyG3";
export const close = "modal-module--close--2ZKUi";
export const content = "modal-module--content--CfH0N";
export const placer = "modal-module--placer--1Y6WQ";